import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router";
import { changePopupVisibility } from '../../../actions/ControlsAction';
import PopupEnum from '../PopupEnum';
import { showCustomPopup } from '../../../actions/PopupAction';

const SiteEventHandler = () => {
    const history = useHistory();
    const dispatch = useDispatch()
    useEffect(() => {
        window.addEventListener("message", postMessageHadler);
        //cleanup
        return () => {
            window.removeEventListener("message", postMessageHadler);
        }
    }, []);

    const postMessageHadler = (event) => {
        const { type, message } = event?.data;

        switch (type) {
            case `dgb-route-change`:
                history.push(message?.url);
                break;
            case `verification-popup`:
            case `verificationPopup`:
                dispatch(changePopupVisibility(PopupEnum.SportBetVerification));
                break;
            case `dgb-open-popup`:
                dispatch(showCustomPopup(message?.popupName));
                break;
            default:
                break;
        }

    }

    return <></>;
}
export default SiteEventHandler;